import { useInfiniteQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchServCategoryXServCdRange, fetchServiceCategoryHistFact, fetchServiceCodeRangeFact, fetchServicesAll } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";

const limit = 20
const ServiceCategories = () => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();

    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["serviceCategories", limit, decouncedSearchValue],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue) {
                params.serviceCategoryName = decouncedSearchValue;
            }

            return await fetchServiceCategoryHistFact({ ...params, limit });
        },

        select: (data) => {
            //   console.log({ data });
            return { count: data.pages?.[0]?.count, rows: data.pages.map((page) => page.rows).flatMap((x) => x) };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            const hasMore = lastPage?.rows?.length === limit;

            if (!hasMore) return undefined;
            return {
                offset: pages.reduce((accum, page) => {
                    return accum + page.rows.length;
                }, 0),
            };
        },
        staleTime: 0,
        enabled: true,
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['serviceCategoryName', 'definition', 'showInPortal', 'serviceCategoryTypeCode'];

    const onDetailHandler = async (body) => {
        //TODO diagnosis


        //services
        const range = await fetchServCategoryXServCdRange({
            limit: 100,
            serviceCategoryHistFactKey: body.serviceCategoryHistFactKey
        })

        const rangeTasks = range.rows.map(row => fetchServiceCodeRangeFact({ serviceCodeRangeFactKey: row.serviceCodeRangeFactKey }))
        // if (body.definition.includes('service') && !body.definition.includes('category')) {

        // }
        const ranges = await Promise.all(rangeTasks)

        const codes = await Promise.all(ranges.map(r => fetchServicesAll({ serviceCode: r.rows[0].serviceCodeRangeStart })))
        return { serviceCodes: codes.map(c => c.rows[0]) }
    }

    return (
        <div className={'container '}>
            <p className='title'>Service Categories  ( {data?.count || 0} )</p>
            <p className="sub-title">Service codes are group in categories</p>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>


                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />
                </div>
            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"service-categories"}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onEditHandler={onEditHandler}
                        onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default ServiceCategories